import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { UsuarioPermissaoService } from '@services/usuario-permissao.service';
import { ToastrService } from 'ngx-toastr';
import { finalize, take } from 'rxjs/operators';
import { BaseFormService } from 'src/app/services/base-form.service';
import { buildPaginationItems, PaginationItem } from 'src/app/utils/pagination.utils';
import { UsuarioBeneficioService } from './../../services/usuario-beneficio.service';
import { WindowReferenceService } from '@services/window-reference.service';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { AlertErroComponent } from '../../components/alert-erro/alert-erro.component';
import { ConfirmaExclusaoComponent } from '../dados-empresa/confirma-exclusao/confirma-exclusao.component';
import { AlertSucessoComponent } from '../../components/alert-sucesso/alert-sucesso.component';
import { AlertGenericoComponent } from '../../components/alert-generico/alert-generico.component';
import { AlertErroCustomizadoComponent } from '../../components/alert-erro-customizado/alert-erro-customizado.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { FormsModule } from '@angular/forms';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { SelectComponent } from '../../components/select/select.component';
import { ApiStateComponent } from '../../components/api-state/api-state.component';
import { NgClass, AsyncPipe } from '@angular/common';
import { FooterComponent } from '../../components/footer/footer.component';
import { CpfPipe } from '../../pipes/cpf.pipe';
import { UsuarioPermissaoPipe } from '../../pipes/usuario-permissao.pipe';

@Component({
    selector: 'app-usuario-beneficio',
    templateUrl: './usuario-beneficio.component.html',
    styleUrls: ['./usuario-beneficio.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingGenericoComponent, HeaderComponent, BotaoChatComponent, AlertErroComponent, ConfirmaExclusaoComponent, AlertSucessoComponent, AlertGenericoComponent, AlertErroCustomizadoComponent, BreadcrumbComponent, FormsModule, PopoverDirective, SelectComponent, ApiStateComponent, NgClass, RouterLink, FooterComponent, AsyncPipe, CpfPipe, UsuarioPermissaoPipe]
})
export class UsuarioBeneficioComponent
  extends BaseFormService
  implements OnInit {
  public idEmpresaLogada: any = localStorage.idEmpresaLogada;
  public status = 'S';
  public usuarios: any = null;

  public searchTextFilter: any = '';
  public searchTextFilterUsers: any;
  public usuarioEncontrado: boolean = true;

  public checkedUsersId: number[] = [];
  public usuarioEnviado: any = '';

  // VARIAVEIS DOS ALERTS
  public alertErro: boolean = false;
  public mensagemErro: any;
  public alertConfirmacao: boolean = false;
  public loadingGenerico: boolean = false;
  public isTodosSelecionados = false;

  // VARIÁVEIS PAGINAÇÃO
  pagina: any = 0;
  tamanho: any = 6;
  itensPaginacao: PaginationItem[] = [];
  usuariosBeneficios: Array<any> = [];
  showAlertSucesso: boolean;
  mensagemSucesso: string;
  showAlertRoteirizacao: boolean;
  erroListaUsuarios: boolean;
  mensagemErroListaUsuarios: string;
  tituloMensagemErroListaUsuarios: string;
  botaoErroListaUsuarios: any;
  searchTextFilterFormatted: any;
  pedidoAtivoFinalizado: boolean;

  constructor(
    private readonly usuarioBeneficioService: UsuarioBeneficioService,
    private readonly router: Router,
    private readonly toastr: ToastrService,
    private readonly activatedRoute: ActivatedRoute,
    public usuarioPermissaoService: UsuarioPermissaoService,
    public rota: Router,
    private readonly windowRef: WindowReferenceService,
  ) {
    super();
  }

  ngOnInit(): void {
    if (
      sessionStorage.usuarioBeneficioPaginaUsuario &&
      sessionStorage.usuarioBeneficioUsuariosPorPagina
    ) {
      this.pagina = Number.parseInt(sessionStorage.usuarioBeneficioPaginaUsuario);
      this.tamanho = sessionStorage.usuarioBeneficioUsuariosPorPagina;
      this.status = sessionStorage.usuarioBeneficioStatus;
      sessionStorage.removeItem('usuarioBeneficioPaginaUsuario');
      sessionStorage.removeItem('usuarioBeneficioUsuariosPorPagina');
      sessionStorage.removeItem('usuarioBeneficioStatus');
    }
    if (sessionStorage.recarregaPagina) {
      sessionStorage.removeItem('recarregaPagina');
      this.windowRef.reload();
    }
    this.usuarioBeneficioService.cleanSelectedUsers();
    this.getApiData();
    this.pedidoAtivoEmAndamento();
  }

  // API PARA OBTER OS USUARIOS
  getApiData() {
    this.usuarios = null;

    this.usuarioBeneficioService.getAllUsuarios(this.idEmpresaLogada, this.pagina, this.tamanho, this.status, this.usuarioEnviado).
      pipe(take(1))
      .subscribe({
        next: (resposta: any) => {
          if (resposta.status == 'OK') {
            this.usuarios = resposta.response;
            this.usuariosBeneficios = resposta.response.data;
            this.carregarUsuariosSelecionados();
            this.configsPaginacao();
          } else if (
              resposta.response.pageRequest?.totalPages != 0 &&
              this.pagina != 0
            ) {
              this.pagina = resposta.response.pageRequest.totalPages - 1;
              this.getApiData();
            } else {
              this.usuarios = undefined;
            }
        },
        error: (error: any) => {
          console.error(error);
          this.usuarios = false;
        }
      });
  }

  private carregarUsuariosSelecionados() {

    this.checkedUsersId = this.getAllSelectedUsers().map((user) => user.idUsuario);
    this.isTodosSelecionados = true;

    this.usuariosBeneficios.forEach(u => {
      if(!this.checkedUsersId.includes(u.idUsuario)) {
        this.isTodosSelecionados = false;
        u.checked = false;
      }
      if (this.checkedUsersId.includes(u.idUsuario)) {
        u.checked = true;
      }
    });
  }

  editarUsuario(usuario: any) {
    sessionStorage.usuarioBeneficioPaginaUsuario = this.pagina;
    sessionStorage.usuarioBeneficioUsuariosPorPagina = this.tamanho;
    sessionStorage.usuarioBeneficioStatus = this.status;
    this.router.navigate(['/dados-usuario/', usuario.idUsuario]);
  }

  /** método responsável por criar a estrutura de parâmetros da seguinte forma:  [ { name: <nomeParam> , comparator : <comparator> , value : <value> } ] */
  getParamsFormatArray() {
    let arr = [];

    arr.push(
      {name: 'pagina', comparator: '=', value: this.pagination.currentPageApi,},
      {name: 'tamanho', comparator: '=', value: this.pagination.pageSize,}
    );
    /** incluindo a busca de usuários */
    if (this.searchTextFilter.length >= 4) {
      arr.push({ name: 'nome', comparator: '=', value: this.usuarioEnviado });
    }
    /** incluindo a busca de ativos */
    if (this.status) {
      arr.push({ name: 'status', comparator: '=', value: this.status });
    }

    return arr;
  }

  searchUserFilter() {
    if (this.searchTextFilterFormatted.length >= 5) {
      this.loadingGenerico = true;

      this.usuarioBeneficioService.getUsuarioSearchFilter(this.idEmpresaLogada, this.searchTextFilterFormatted)
      .pipe(take(1)).subscribe({
        next: (res: any) => {
          this.searchTextFilterUsers = res.response;
          this.loadingGenerico = false;
          this.usuarioEncontrado = !!(res.response?.length);
        },
        error: (error: any) => {
          console.error(error);
          this.loadingGenerico = false;
          this.usuarioEncontrado = false;
        }
      });
    }
  }

  closeSearchTextFilter(user) {
    if (user) {
      this.searchTextFilter = user.nomeUsuario;
      this.usuarioEnviado = user.nomeUsuario;
      this.searchTextFilterUsers = "";
      this.searchTextFilterFormatted = "";
    } else {
      this.searchTextFilter = "";
      this.searchTextFilterFormatted = "";

    }
  }

  formatSearchText() {
    if(this.searchTextFilter != ""){
      const regex = /[.,/-]/g;
      this.searchTextFilterFormatted =  this.searchTextFilter.replace(regex, '');
    }
  }

  selecionaTodos(input: any) {
    let checkboxes = document.querySelectorAll("input[type='checkbox']");

    function transformAllTrue(item: any) {
      if (!item.checked) {
        item.click();
      }
    }
    function transformAllFalse(item: any) {
      if (item.checked) {
        item.click();
      }
    }

    if (input.checked === true) {
      this.isTodosSelecionados = true;
      checkboxes.forEach(transformAllTrue);
      this.usuariosBeneficios.forEach(u => {
        u.checked = true;
        this.usuarioBeneficioService.addUserIfNotExists(u);
      });
    } else {
      this.isTodosSelecionados = false;
      checkboxes.forEach(transformAllFalse);
      this.usuariosBeneficios.forEach(u => {
        u.checked = false;
        this.usuarioBeneficioService.removeUserIfExists(u);
      });
    }
  }

  checkboxTableClick(user) {

    if (user) {
      let res = this.checkedUsersId.findIndex((x) => {
        return x == user.idUsuario;
      });

      if (res < 0) {

        this.checkedUsersId.push(user.idUsuario);
        this.usuarioBeneficioService.addUserIfNotExists(user);
      } else {

        this.checkedUsersId.splice(res, 1);
        this.usuarioBeneficioService.removeUserIfExists(user);
      }
    }
    this.carregarUsuariosSelecionados();
  }

  activeUsers() {
    this.alterarStatusUsuarios('N', 'S', 'Usuários ativos com sucesso!', 'não se pode ativar um usuário já ativo');
  }

  desactiveUsers() {
    this.alterarStatusUsuarios('S', 'N', 'Usuários desativados com sucesso!', 'não se pode desativar um usuário já desativado');
  }

  private alterarStatusUsuarios(flagEsperada: string, novoStatus: string, mensagemSucesso: string, mensagemErro: string) {
    if (!this.checkedUsersId.length) return;

    const usuarioParaAtualizar = this.usuariosBeneficios.find(user =>
      this.checkedUsersId.some(id => user.idUsuario.toString() == id) && user.flagAtivo == flagEsperada
    );

    if (!usuarioParaAtualizar) {
      this.toastr.error(mensagemErro);
      return;
    }

    this.loadingGenerico = true;
    this.usuarioBeneficioService.updateStatusUsers(this.idEmpresaLogada, this.checkedUsersId, novoStatus)
      .pipe(take(1), finalize(() => this.loadingGenerico = false))
      .subscribe({
        next: () => {
          this.toastr.success(mensagemSucesso);
          this.usuarioBeneficioService.cleanSelectedUsers();
          this.filtrar();
        },
        error: (error: any) => console.error(error)
      });
  }


  deleteUsers() {
    if (this.checkedUsersId.length > 0) {
      this.loadingGenerico = true;
      this.usuarioBeneficioService.deleteUserById(this.checkedUsersId)
      .pipe(
        take(1),
        finalize(
          ()=> this.loadingGenerico = false
        )).subscribe({
          next: (res: any) => {
            this.toastr.success(`Usuário(s) excluídos com sucesso!`);
            this.usuarioBeneficioService.cleanSelectedUsers();
            this.filtrar();
          },
          error: (erro: any) => {
            console.error(erro);
            this.mensagemErro = 'Erro ao excluir usuário, tente novamente.';
            this.abriAlertErro();
          }
        });
    } else {
      this.mensagemErro = 'Erro, nenhum usuário adicionado para a exclusão';
      this.abriAlertErro();
    }
  }

  public eventoAlertErroFechou(event: any) {
    this.alertErro = event;
  }

  public abriAlertErro() {
    this.alertErro = true;
  }

  filtrar() {
    this.usuariosBeneficios = [];
    this.pagina = 0;
    this.getApiData();
  }

  limparFiltro() {
    this.usuariosBeneficios = [];
    this.searchTextFilter = '';
    this.searchTextFilterFormatted = '';
    this.status = 'S';
    this.searchTextFilterUsers = '';
    this.usuarioEnviado = '';
    this.usuarioEncontrado = true;
    this.pagina = 0;
    this.getApiData();
  }

  // FUNÇÕES NOVA PAGINAÇÃO (REFORMULAÇÃO - JOAO)
  // FUNÇÕES DA PAGINAÇÃO
  alteraPagina(numeroPagina: any) {
    if (this.pagina != numeroPagina && numeroPagina != '...') {
      this.usuariosBeneficios = [];
      this.checkedUsersId = [];
      this.pagina = numeroPagina;
      this.getApiData();
    }
  }

  alteraQuantidadePorPagina() {
    this.usuariosBeneficios = [];
    this.checkedUsersId = [];
    this.pagina = 0;
    this.getApiData();
  }

  configsPaginacao() {
    this.itensPaginacao = buildPaginationItems(this.pagina, this.usuarios.pageRequest.totalPages);
  }

  // ALERT CONFIRMACAO
  // PASSO 1 - MOSTRA O ALERT DE CONFIRMAÇÃO PERGUTANDO SE DESEJA EXCLUIR
  confirmarExclusaoContato() {
    this.alertConfirmacao = true;
  }

  fecharAlertConfirmacao(evento: string) {
    // Se clicar no botão de CONFIRMAR ele chama a função pra excluir
    if (evento === 'Confirmar') {
      this.alertConfirmacao = false;
      this.deleteUsers();
    } else {
      // Se não apenas fecha o alert de confirmação e não faz nada
      this.alertConfirmacao = false;
    }
  }

  confirmarRotaEmLote() {
    if (this.checkedUsersId.length == 0) {
      this.setErroListaUsuario();
    } else {
      this.showAlertRoteirizacao = true;
    }
  }

  postConsultaRotaEmLote() {

    if (this.checkedUsersId.length != 0) {
      let lista = {
        idEmpresa: this.idEmpresaLogada,
        usuarios: this.checkedUsersId
      }
      this.loadingGenerico = true;
      this.showAlertRoteirizacao = false;

      this.usuarioBeneficioService.postConsultaRotaEmLote(lista)
      .subscribe({
        next: (response: any) => {
          if (response.status == 'OK') {
            this.consultaRotaEmLoteFinalizada();
            this.checkedUsersId.length = 0;
          }
          this.loadingGenerico = false;
        },
        error: (error: any) => {
          console.error(error);
        }
      });
    }
  }

  setErroListaUsuario(){
    this.erroListaUsuarios = true;
    this.mensagemErroListaUsuarios = 'Favor selecionar usuários e tentar novamente.';
    this.tituloMensagemErroListaUsuarios = 'Nenhum usuário foi selecionado';
    this.botaoErroListaUsuarios = "FECHAR";
    this.showAlertRoteirizacao = false;
  }

  fecharAlertListaUsuariosError(){
    this.erroListaUsuarios = false;
  }

  fechouConfirmaRotaEmLote() {
    this.showAlertRoteirizacao = false;
  }

  consultaRotaEmLoteFinalizada() {
    this.showAlertSucesso = true;
    this.mensagemSucesso = "Sugestão de rotas realizadas"
  }

  fechouRotaEmLote() {
    this.showAlertSucesso = false;
    this.getApiData();
  }

  roteirizacaoEmLote = {
    buttons: [
      {
        action: () => {
          this.postConsultaRotaEmLote();
        },
        className: 'botao-secundario-outline mx-3',
        text: 'SIM',
      },
      {
        action: () => {
          this.fechouConfirmaRotaEmLote();
        },
        className: 'botao-cancelar-outline mx-3',
        text: 'NÃO',
      },
    ],
    description: 'Confirmar os usuários selecionados?',
    message: 'Confirmar os usuários selecionados?',
  };

  pedidoAtivoEmAndamento(){
    if (!localStorage.empresaNova){
      this.usuarioBeneficioService.pedidoAtivoStatus(this.idEmpresaLogada).pipe(take(1))
      .subscribe({
        next: (response: any) => {
          if (response.status === 'NOK') {
            this.pedidoAtivoFinalizado = false;
          }
        },
        error: (error: any) => {
          console.error(error);
        }
      });
    }
  }

  getAllSelectedUsers(): any[] {
    return this.usuarioBeneficioService.getAllSelectedUsers();
  }

  hasSelectedUsers(): boolean {
    return this.usuarioBeneficioService.getAllSelectedUsers().length > 0;
  }

  fazerPedidoAvulso() {

    const allSelectedUsers = this.getAllSelectedUsers();
    this.rota.navigate(['/fazer-pedido-avulso'], {
      state: { users: allSelectedUsers }
    });
  }
}
